import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "run",
  "description": "`turbo run` 명령어의 API 레퍼런스입니다."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "turbo.json에 지정된 작업을 실행합니다."
  }, {
    "heading": "",
    "content": "[tasks]: Turborepo는 한 번에 하나 또는 여러 작업을 실행할 수 있습니다. turbo를 통해 작업을 실행하려면 turbo.json에 지정되어야 합니다."
  }, {
    "heading": "",
    "content": "[options]: 옵션은 turbo run 명령어의 동작을 제어하는 데 사용됩니다. 사용 가능한 플래그 옵션은 아래에 설명되어 있습니다."
  }, {
    "heading": "",
    "content": "[-- [args passed to tasks]]: 하위 스크립트에 인수를 전달할 수도 있습니다. 모든 인수는 run 명령에 지정된 모든 작업에 전달됩니다."
  }, {
    "heading": "",
    "content": "turbo run은 turbo의 별칭입니다. turbo run build lint check-types는\nturbo build lint check-types와 동일합니다. 사용 편의성을 위해 CI\n파이프라인에서는 turbo\n  run을,\n로컬에서는 전역\nturbo와 함께\nturbo를 사용하는 것을 권장합니다."
  }, {
    "heading": "",
    "content": "작업이 제공되지 않으면 turbo는 저장소의 패키지에서 사용 가능한 작업을 표시합니다."
  }, {
    "heading": "--affected",
    "content": "현재 브랜치의 변경 사항에 영향을 받는 패키지만 필터링합니다."
  }, {
    "heading": "--affected",
    "content": "기본적으로 이 플래그는 --filter=...[main...HEAD]와 동일합니다. 이는 Git의 관점에서 main과 HEAD 사이의 변경 사항을 고려합니다."
  }, {
    "heading": "--affected",
    "content": "비교를 위해서는 base와 head 사이의 모든 내용이 체크아웃에 존재해야 합니다. 체크아웃이 너무 얕으면 모든 패키지가 변경된 것으로 간주됩니다."
  }, {
    "heading": "--affected",
    "content": "예를 들어, Git을 --filter=blob:none --depth=0으로 체크아웃하도록 설정하면 --affected가 올바르게 작동하는 데 필요한 히스토리를 확보할 수 있습니다."
  }, {
    "heading": "--affected",
    "content": "각각의 시스템 환경 변수를 사용하여 기본 base와 head를 재정의할 수 있습니다."
  }, {
    "heading": "--cache-options",
    "content": "기본값: local:rw,remote:rw"
  }, {
    "heading": "--cache-options",
    "content": "실행할 캐싱 소스를 지정합니다. 쉼표로 구분된 옵션 목록을 허용합니다:"
  }, {
    "heading": "--cache-options",
    "content": "local: 로컬 파일 시스템 캐시 사용"
  }, {
    "heading": "--cache-options",
    "content": "remote: Remote Cache 사용"
  }, {
    "heading": "--cache-options",
    "content": "캐싱 소스가 생략되면 읽기와 쓰기가 모두 비활성화됩니다."
  }, {
    "heading": "--cache-options",
    "content": "캐시 소스는 다음 값을 사용합니다:"
  }, {
    "heading": "--cache-options",
    "content": "rw: 읽기 및 쓰기"
  }, {
    "heading": "--cache-options",
    "content": "r: 읽기 전용"
  }, {
    "heading": "--cache-options",
    "content": "w: 쓰기 전용"
  }, {
    "heading": "--cache-options",
    "content": "없음 (local:): 캐시를 사용하지 않습니다. 캐시 소스 옵션을 생략하는 것과 동일합니다."
  }, {
    "heading": "--cache-dir-path",
    "content": "기본값: .turbo/cache"
  }, {
    "heading": "--cache-dir-path",
    "content": "파일 시스템 캐시 디렉토리를 지정합니다."
  }, {
    "heading": "--cache-dir-path",
    "content": "변경할 때 디렉토리가 .gitignore에 있는지 확인하세요."
  }, {
    "heading": "--cache-dir-path",
    "content": "동일한 동작은 TURBO_CACHE_DIR=example/path 시스템 변수를 통해서도 설정할 수 있습니다."
  }, {
    "heading": "--concurrency-number--percentage",
    "content": "기본값: 10"
  }, {
    "heading": "--concurrency-number--percentage",
    "content": "작업 실행의 최대 동시성을 설정/제한합니다. 1 이상의 정수 또는 50%와 같은 백분율 값이어야 합니다."
  }, {
    "heading": "--concurrency-number--percentage",
    "content": "직렬 실행(한 번에 하나의 작업)을 강제하려면 1을 사용합니다."
  }, {
    "heading": "--concurrency-number--percentage",
    "content": "사용 가능한 모든 논리 프로세서를 사용하려면 100%를 사용합니다."
  }, {
    "heading": "--concurrency-number--percentage",
    "content": "--parallel 플래그도 전달되면 이 옵션은 무시됩니다."
  }, {
    "heading": "--continueoption",
    "content": "기본값: never"
  }, {
    "heading": "--continueoption",
    "content": "오류가 발생할 때(예: 작업에서 0이 아닌 종료 코드) turbo가 현재 및 대기 중인 작업을 처리하는 방법을 지정합니다."
  }, {
    "heading": "--continueoption",
    "content": "--continue=never이고 오류가 발생하면 turbo는 모든 작업을 취소합니다."
  }, {
    "heading": "--continueoption",
    "content": "--continue=dependencies-successful이고 오류가 발생하면 turbo는 종속 작업을 취소합니다. 종속성이 성공한 작업은 계속 실행됩니다."
  }, {
    "heading": "--continueoption",
    "content": "--continue=always이고 오류가 발생하면 turbo는 종속성이 실패한 작업을 포함하여 모든 작업을 계속 실행합니다."
  }, {
    "heading": "--continueoption",
    "content": "--continue가 값 없이 지정되면 기본값은 always입니다."
  }, {
    "heading": "--continueoption",
    "content": "모든 경우에 turbo는 실행 중 발생한 가장 높은 종료 코드 값으로 종료됩니다."
  }, {
    "heading": "--cwd-path",
    "content": "기본값: 루트 turbo.json의 디렉토리"
  }, {
    "heading": "--cwd-path",
    "content": "명령의 작업 디렉토리를 설정합니다."
  }, {
    "heading": "--dangerously-disable-package-manager-check",
    "content": "Turborepo는 저장소의 lockfile을 사용하여 캐싱 동작, 패키지 그래프 등을 결정합니다. 이 때문에 Turborepo를 안정화하는 데 도움이 되도록 packageManager 필드를 사용합니다."
  }, {
    "heading": "--dangerously-disable-package-manager-check",
    "content": "점진적 마이그레이션을 돕거나 packageManager 필드를 사용할 수 없는 상황에서 --dangerously-disable-package-manager-check를 사용하여 이 검사를 선택 해제하고 불안정한 lockfile이 예측할 수 없는 동작을 생성할 위험을 감수할 수 있습니다. 비활성화되면 Turborepo는 저장소에 의도된 패키지 매니저를 최선의 노력으로 검색을 시도합니다."
  }, {
    "heading": "--dangerously-disable-package-manager-check",
    "content": "더 광범위한 적용을 위해 turbo.json의\n설정\n또는\nTURBO_DANGEROUSLY_DISABLE_PACKAGE_MANAGER_CHECK\n환경 변수를 사용하여 이 검사를 선택 해제할 수도 있습니다."
  }, {
    "heading": "--dry----dry-run",
    "content": "작업을 실행하는 대신 실행될 패키지와 작업에 대한 세부 정보를 표시합니다."
  }, {
    "heading": "--dry----dry-run",
    "content": "JSON 형식으로 출력을 얻으려면 --dry=json을 지정합니다."
  }, {
    "heading": "--dry----dry-run",
    "content": "작업 세부 정보에는 다음과 같은 유용한 정보가 포함됩니다(목록은 전체가 아님):"
  }, {
    "heading": "--dry----dry-run",
    "content": "필드"
  }, {
    "heading": "--dry----dry-run",
    "content": "설명"
  }, {
    "heading": "--dry----dry-run",
    "content": "taskId"
  }, {
    "heading": "--dry----dry-run",
    "content": "package-name#task-name 형식의 작업 ID"
  }, {
    "heading": "--dry----dry-run",
    "content": "task"
  }, {
    "heading": "--dry----dry-run",
    "content": "실행할 작업의 이름"
  }, {
    "heading": "--dry----dry-run",
    "content": "package"
  }, {
    "heading": "--dry----dry-run",
    "content": "작업을 실행할 패키지"
  }, {
    "heading": "--dry----dry-run",
    "content": "hash"
  }, {
    "heading": "--dry----dry-run",
    "content": "작업의 해시(캐싱에 사용됨)"
  }, {
    "heading": "--dry----dry-run",
    "content": "hashOfExternalDependencies"
  }, {
    "heading": "--dry----dry-run",
    "content": "전역 해시"
  }, {
    "heading": "--dry----dry-run",
    "content": "command"
  }, {
    "heading": "--dry----dry-run",
    "content": "작업을 실행하는 데 사용되는 명령"
  }, {
    "heading": "--dry----dry-run",
    "content": "inputs"
  }, {
    "heading": "--dry----dry-run",
    "content": "해싱을 위해 고려된 파일 입력 목록"
  }, {
    "heading": "--dry----dry-run",
    "content": "outputs"
  }, {
    "heading": "--dry----dry-run",
    "content": "캐시된 파일 출력 목록"
  }, {
    "heading": "--dry----dry-run",
    "content": "dependencies"
  }, {
    "heading": "--dry----dry-run",
    "content": "이 작업 이전에 실행되어야 하는 작업"
  }, {
    "heading": "--dry----dry-run",
    "content": "dependents"
  }, {
    "heading": "--dry----dry-run",
    "content": "이 작업 이후에 실행되어야 하는 작업"
  }, {
    "heading": "--dry----dry-run",
    "content": "environmentVariables"
  }, {
    "heading": "--dry----dry-run",
    "content": "env 및 passThroughEnv에 지정된 환경 변수 목록"
  }, {
    "heading": "--env-mode-option",
    "content": "type: string"
  }, {
    "heading": "--env-mode-option",
    "content": "작업의 런타임에서 사용 가능한 환경 변수를 제어합니다."
  }, {
    "heading": "--env-mode-option",
    "content": "PATH, SHELL, SYSTEMROOT는 항상 작업에서 사용할 수 있습니다."
  }, {
    "heading": "--env-mode-option",
    "content": "옵션"
  }, {
    "heading": "--env-mode-option",
    "content": "설명"
  }, {
    "heading": "--env-mode-option",
    "content": "strict (기본값)"
  }, {
    "heading": "--env-mode-option",
    "content": "명시적으로 나열된 환경 변수만 사용 가능하도록 허용"
  }, {
    "heading": "--env-mode-option",
    "content": "loose"
  }, {
    "heading": "--env-mode-option",
    "content": "모든 환경 변수를 사용 가능하도록 허용"
  }, {
    "heading": "--env-mode-option",
    "content": "동일한 동작은 TURBO_ENV_MODE=strict 시스템 변수를 통해서도 설정할 수 있습니다."
  }, {
    "heading": "strict",
    "content": "다음 키에 지정된 환경 변수만 작업에서 사용할 수 있습니다:"
  }, {
    "heading": "strict",
    "content": "env"
  }, {
    "heading": "strict",
    "content": "passThroughEnv"
  }, {
    "heading": "strict",
    "content": "globalEnv"
  }, {
    "heading": "strict",
    "content": "globalPassThroughEnv"
  }, {
    "heading": "strict",
    "content": "엄격 모드가 지정되거나 추론되면 구성에 관계없이 모든 작업이 strict 모드에서 실행됩니다."
  }, {
    "heading": "loose",
    "content": "머신의 모든 환경 변수가 작업의 런타임에서 사용 가능하게 됩니다."
  }, {
    "heading": "loose",
    "content": "위의 strict에 나열된 키로 캐싱에 환경 변수가 고려되지 않을 때 위험할 수\n있습니다. loose 모드에서는 캐시에서 잘못된 환경 변수로 패키지 버전을 복원할\n가능성이 훨씬 높습니다."
  }, {
    "heading": "--filter-string",
    "content": "저장소 그래프에서 실행할 대상을 지정합니다. 여러 필터를 결합하여 고유한 대상 집합을 선택할 수 있습니다."
  }, {
    "heading": "--filter-string",
    "content": "필터를 결합하여 패키지, 디렉토리, git 커밋의 조합을 만들 수 있습니다."
  }, {
    "heading": "--filter-string",
    "content": "대상 유형"
  }, {
    "heading": "--filter-string",
    "content": "설명"
  }, {
    "heading": "--filter-string",
    "content": "예시"
  }, {
    "heading": "--filter-string",
    "content": "Package"
  }, {
    "heading": "--filter-string",
    "content": "package.json의 이름으로 패키지를 선택합니다."
  }, {
    "heading": "--filter-string",
    "content": "turbo run build --filter=ui"
  }, {
    "heading": "--filter-string",
    "content": "Directory"
  }, {
    "heading": "--filter-string",
    "content": "작업을 실행할 패키지 목록을 캡처하기 위해 디렉토리를 지정합니다. 다른 필터와 함께 사용할 때는 {}로 래핑해야 합니다."
  }, {
    "heading": "--filter-string",
    "content": "turbo run build --filter=./apps/*"
  }, {
    "heading": "--filter-string",
    "content": "Git commits"
  }, {
    "heading": "--filter-string",
    "content": "Git 지정자를 사용하여 소스 제어 변경 사항이 있는 패키지를 지정합니다. []로 래핑해야 합니다."
  }, {
    "heading": "--filter-string",
    "content": "turbo run build --filter=[HEAD^1]"
  }, {
    "heading": "필터링을-위한-마이크로-구문",
    "content": "!: 선택에서 대상을 제외합니다."
  }, {
    "heading": "필터링을-위한-마이크로-구문",
    "content": "... 패키지 사용: 대상을 기준으로 패키지 그래프의 모든 패키지를 선택합니다. 패키지 이름 앞에 ...를 사용하면 대상의 종속자를 선택하고, 패키지 이름 뒤에 ...를 사용하면 대상의 종속성을 선택합니다."
  }, {
    "heading": "필터링을-위한-마이크로-구문",
    "content": "... Git 커밋 사용: [<from commit>]...[<to commit>]를 사용하여 범위를 선택합니다."
  }, {
    "heading": "필터링을-위한-마이크로-구문",
    "content": "^: ...를 사용할 때 선택에서 대상을 생략합니다."
  }, {
    "heading": "필터링을-위한-마이크로-구문",
    "content": "필터링에 대한 심층적인 논의와 실용적인 사용 사례는 작업 실행 페이지를 참조하세요."
  }, {
    "heading": "작업-식별자-사용",
    "content": "package-name#task-name 형식으로 특정 패키지에 대한 특정 작업을 실행할 수도 있습니다."
  }, {
    "heading": "작업-식별자-사용",
    "content": "이것은 작업의 종속성도 실행합니다. 종속성 없이 작업을 실행하려면 --only\n플래그를 사용하세요."
  }, {
    "heading": "고급-필터링-예제",
    "content": "여러 필터를 결합하여 대상을 더욱 세밀하게 조정할 수 있습니다. 여러 필터는 합집합으로 결합되며, 부정 필터는 합집합의 결과에서 패키지를 제거합니다."
  }, {
    "heading": "--force",
    "content": "기존 캐시된 아티팩트를 무시하고 모든 작업을 다시 실행합니다."
  }, {
    "heading": "--force",
    "content": "동일한 동작은 TURBO_FORCE 환경 변수를 통해서도 설정할 수 있습니다."
  }, {
    "heading": "--framework-inference",
    "content": "기본값: true"
  }, {
    "heading": "--framework-inference",
    "content": "작업에 대해 프레임워크 추론을 수행할지 여부를 지정합니다."
  }, {
    "heading": "--framework-inference",
    "content": "false일 때 자동 환경 변수 포함이 비활성화됩니다."
  }, {
    "heading": "--global-deps-file-glob",
    "content": "해시화할 전역 파일 시스템 종속성의 glob을 지정합니다. 여러 패키지에 영향을 미치는 .env 및 루트 디렉토리의 파일에 유용합니다."
  }, {
    "heading": "--global-deps-file-glob",
    "content": "항상 고려되도록 하기 위해 turbo.json의 globalDependencies\n키에 해시에 포함하려는 파일 glob을\n지정하는 것을 권장합니다."
  }, {
    "heading": "--graph-file-name",
    "content": "기본값: dot"
  }, {
    "heading": "--graph-file-name",
    "content": "이 명령은 그래프 파일을 출력할 수 있습니다: svg, png, jpg, pdf, json, html, mermaid 또는 dot."
  }, {
    "heading": "--graph-file-name",
    "content": "Graphviz가 설치되지 않았거나 파일 이름이 제공되지 않으면 이 명령은 dot 그래프를 stdout에 출력합니다."
  }, {
    "heading": "--graph-file-name",
    "content": "알려진 버그: 현재 특정 패키지에 해당 스크립트가 실제로 존재하지 않더라도\n모든 가능한 작업 노드가 그래프에 추가됩니다. 이는 실행에는 영향을 미치지\n않지만 그래프가 관련된 패키지와 작업의 수를 과대평가할 수 있습니다."
  }, {
    "heading": "--log-order-option",
    "content": "기본값: auto"
  }, {
    "heading": "--log-order-option",
    "content": "로그 출력의 순서를 설정합니다."
  }, {
    "heading": "--log-order-option",
    "content": "기본적으로 turbo는 CI 환경에서 grouped 로그를, 다른 곳에서는 stream 로그를 사용합니다. 이 플래그는 터미널 UI를 사용할 때는 적용되지 않습니다."
  }, {
    "heading": "--log-order-option",
    "content": "옵션"
  }, {
    "heading": "--log-order-option",
    "content": "설명"
  }, {
    "heading": "--log-order-option",
    "content": "stream"
  }, {
    "heading": "--log-order-option",
    "content": "사용 가능한 즉시 출력을 표시합니다"
  }, {
    "heading": "--log-order-option",
    "content": "grouped"
  }, {
    "heading": "--log-order-option",
    "content": "작업별로 출력을 그룹화합니다"
  }, {
    "heading": "--log-order-option",
    "content": "auto"
  }, {
    "heading": "--log-order-option",
    "content": "turbo가 자체 휴리스틱을 기반으로 결정합니다"
  }, {
    "heading": "--log-prefix-option",
    "content": "기본값: auto"
  }, {
    "heading": "--log-prefix-option",
    "content": "작업 실행 시 생성되는 로그 라인의 <package>:<task>: 접두사를 제어합니다."
  }, {
    "heading": "--log-prefix-option",
    "content": "옵션"
  }, {
    "heading": "--log-prefix-option",
    "content": "설명"
  }, {
    "heading": "--log-prefix-option",
    "content": "task"
  }, {
    "heading": "--log-prefix-option",
    "content": "로그에 <package>:<task>: 접두사를 강제로 추가합니다"
  }, {
    "heading": "--log-prefix-option",
    "content": "none"
  }, {
    "heading": "--log-prefix-option",
    "content": "접두사 없음"
  }, {
    "heading": "--log-prefix-option",
    "content": "auto"
  }, {
    "heading": "--log-prefix-option",
    "content": "turbo가 자체 휴리스틱을 기반으로 결정합니다"
  }, {
    "heading": "--no-cache",
    "content": "이 플래그는 향후 주요 릴리스에서 제거될 예정입니다. 대신\n--cache 플래그를 사용하세요."
  }, {
    "heading": "--no-cache",
    "content": "기본값: false"
  }, {
    "heading": "--no-cache",
    "content": "작업의 결과를 캐시하지 않습니다."
  }, {
    "heading": "--daemon-및---no-daemon",
    "content": "turbo는 수행해야 할 작업을 결정하는 데 사용되는 값을 사전 계산하기 위해 백그라운드 프로세스를 실행할 수 있습니다. 이 독립 실행형 프로세스(daemon)는 최적화이며 turbo의 적절한 기능에는 필요하지 않습니다."
  }, {
    "heading": "--daemon-및---no-daemon",
    "content": "기본 daemon 사용은 turbo.json의 daemon 필드를 사용하여 저장소에 대해 설정됩니다. --daemon을 전달하면 turbo가 독립 실행형 프로세스를 사용해야 하며, --no-daemon은 turbo가 독립 실행형 프로세스를 사용하거나 생성하지 않도록 지시합니다."
  }, {
    "heading": "--daemon-및---no-daemon",
    "content": "동일한 동작은 TURBO_DAEMON=true 시스템 변수를 통해서도 설정할 수 있습니다."
  }, {
    "heading": "--output-logs-option",
    "content": "기본값: full"
  }, {
    "heading": "--output-logs-option",
    "content": "출력 로깅 유형을 설정하며, turbo.json에 정의된 경우 outputLogs를 재정의합니다."
  }, {
    "heading": "--output-logs-option",
    "content": "옵션"
  }, {
    "heading": "--output-logs-option",
    "content": "설명"
  }, {
    "heading": "--output-logs-option",
    "content": "full"
  }, {
    "heading": "--output-logs-option",
    "content": "모든 로그를 표시합니다"
  }, {
    "heading": "--output-logs-option",
    "content": "hash-only"
  }, {
    "heading": "--output-logs-option",
    "content": "작업의 해시만 표시합니다"
  }, {
    "heading": "--output-logs-option",
    "content": "new-only"
  }, {
    "heading": "--output-logs-option",
    "content": "캐시 미스의 로그만 표시합니다"
  }, {
    "heading": "--output-logs-option",
    "content": "errors-only"
  }, {
    "heading": "--output-logs-option",
    "content": "작업 실패의 로그만 표시합니다"
  }, {
    "heading": "--output-logs-option",
    "content": "none"
  }, {
    "heading": "--output-logs-option",
    "content": "모든 작업 로그를 숨깁니다"
  }, {
    "heading": "--only",
    "content": "기본값: false"
  }, {
    "heading": "--only",
    "content": "실행을 지정된 작업만 포함하도록 제한합니다."
  }, {
    "heading": "예시",
    "content": "다음 turbo.json이 주어졌을 때:"
  }, {
    "heading": "예시",
    "content": "이 명령은 각 패키지의 test 작업만 실행합니다. build는 실행하지 않습니다."
  }, {
    "heading": "예시",
    "content": "또한 --only는 종속성을 제외하고 지정된 패키지의 작업만 실행합니다. 예를 들어, turbo run build --filter=web --only는 web 패키지의 build 스크립트만 실행합니다."
  }, {
    "heading": "--parallel",
    "content": "기본값: false"
  }, {
    "heading": "--parallel",
    "content": "작업 종속성 그래프를 무시하고 패키지 간에 명령을 병렬로 실행합니다."
  }, {
    "heading": "--parallel",
    "content": "--parallel 플래그는 일반적으로 종료되지 않는 장기 실행 \"dev\" 또는 \"watch\"\n작업에 사용됩니다. turbo@1.7부터는 대신\npersistent를 사용하여 이러한\n작업을 구성하는 것을 권장합니다."
  }, {
    "heading": "--preflight",
    "content": "Remote Caching이 구성된 경우에만 적용됩니다. 모든 캐시 아티팩트 및 분석 요청 전에 preflight 요청 전송을 활성화합니다. 후속 업로드 및 다운로드는 리디렉션을 따릅니다."
  }, {
    "heading": "--preflight",
    "content": "동일한 동작은 TURBO_PREFLIGHT=true 시스템 변수를 통해서도 설정할 수 있습니다."
  }, {
    "heading": "--profile",
    "content": "성능 분석에 사용할 수 있는 Chrome Tracing 형식의 실행 추적을 생성합니다."
  }, {
    "heading": "--profile",
    "content": "추적을 생성하려면 --profile과 함께 자세한 정도 플래그(-v, -vv 또는 -vvv)를 제공해야 합니다."
  }, {
    "heading": "--profile",
    "content": "프로필은 Perfetto와 같은 도구에서 볼 수 있습니다."
  }, {
    "heading": "--remote-cache-timeout",
    "content": "기본값: 30"
  }, {
    "heading": "--remote-cache-timeout",
    "content": "Remote Cache 작업의 타임아웃을 초 단위로 설정합니다."
  }, {
    "heading": "--remote-only",
    "content": "이 플래그는 향후 주요 릴리스에서 제거될 예정입니다. 대신\n--cache 플래그를 사용하세요."
  }, {
    "heading": "--remote-only",
    "content": "기본값: false"
  }, {
    "heading": "--remote-only",
    "content": "모든 작업에 대해 로컬 파일 시스템 캐시를 무시하고 Remote Cache를 사용하여 작업 출력을 읽고 캐싱합니다."
  }, {
    "heading": "--summarize",
    "content": "다음을 포함하여 실행에 대한 메타데이터가 포함된 JSON 파일을 .turbo/runs에 생성합니다:"
  }, {
    "heading": "--summarize",
    "content": "영향을 받은 패키지"
  }, {
    "heading": "--summarize",
    "content": "실행된 작업(타이밍 및 해시 포함)"
  }, {
    "heading": "--summarize",
    "content": "캐시된 아티팩트에 포함된 모든 파일"
  }, {
    "heading": "--summarize",
    "content": "이 플래그는 다음과 같은 항목을 확인하기 위한 디버깅에 유용할 수 있습니다:"
  }, {
    "heading": "--summarize",
    "content": "turbo가 inputs 및 outputs에 대한 glob 구문을 해석한 방법"
  }, {
    "heading": "--summarize",
    "content": "캐시 미스를 발생시키기 위해 두 작업 실행 사이에 변경된 입력"
  }, {
    "heading": "--summarize",
    "content": "시간이 지남에 따라 작업 타이밍이 어떻게 변경되었는지"
  }, {
    "heading": "--summarize",
    "content": "Turborepo 네이티브 실행 요약 UI 뷰어는 없지만, 실행 요약을 웹 뷰로 보려면\n커뮤니티에서 만든\nhttps://turbo.nullvoxpopuli.com을 사용하는\n것을 권장합니다."
  }, {
    "heading": "--token",
    "content": "Remote Caching을 위한 bearer 토큰입니다. --team 플래그와 함께 비대화형 셸에서 실행할 때 유용합니다."
  }, {
    "heading": "--token",
    "content": "이 값은 TURBO_TOKEN 시스템 변수를 사용하여 설정할 수도 있습니다. 둘 다 있는 경우 플래그 값이 시스템 변수를 재정의합니다."
  }, {
    "heading": "--token",
    "content": "Vercel Remote Cache를\n사용하고 Vercel에서 프로젝트를 빌드하는 경우 이 플래그를 사용할 필요가\n없습니다. 이 값은 자동으로 설정됩니다."
  }, {
    "heading": "--team",
    "content": "Remote Cache 팀의 슬러그입니다. --token 플래그와 함께 비대화형 셸에서 실행할 때 유용합니다."
  }, {
    "heading": "--team",
    "content": "이 값은 TURBO_TEAM 시스템 변수를 사용하여 설정할 수도 있습니다. 둘 다 있는 경우 플래그 값이 시스템 변수를 재정의합니다."
  }, {
    "heading": "--ui",
    "content": "출력에 사용할 UI를 지정합니다. stream 또는 tui를 허용합니다."
  }, {
    "heading": "--verbosity",
    "content": "로그 레벨을 지정하려면 --verbosity=<num> 또는 -v, -vv, -vvv를 사용합니다."
  }, {
    "heading": "--verbosity",
    "content": "레벨"
  }, {
    "heading": "--verbosity",
    "content": "플래그 값"
  }, {
    "heading": "--verbosity",
    "content": "단축형"
  }, {
    "heading": "--verbosity",
    "content": "Info"
  }, {
    "heading": "--verbosity",
    "content": "--verbosity=1"
  }, {
    "heading": "--verbosity",
    "content": "-v"
  }, {
    "heading": "--verbosity",
    "content": "Debug"
  }, {
    "heading": "--verbosity",
    "content": "--verbosity=2"
  }, {
    "heading": "--verbosity",
    "content": "-vv"
  }, {
    "heading": "--verbosity",
    "content": "Trace"
  }, {
    "heading": "--verbosity",
    "content": "--verbosity=3"
  }, {
    "heading": "--verbosity",
    "content": "-vvv"
  }],
  "headings": [{
    "id": "옵션",
    "content": "옵션"
  }, {
    "id": "--affected",
    "content": "--affected"
  }, {
    "id": "--cache-options",
    "content": "--cache <options>"
  }, {
    "id": "--cache-dir-path",
    "content": "--cache-dir <path>"
  }, {
    "id": "--concurrency-number--percentage",
    "content": "--concurrency <number | percentage>"
  }, {
    "id": "--continueoption",
    "content": "--continue[=<option>]"
  }, {
    "id": "--cwd-path",
    "content": "--cwd <path>"
  }, {
    "id": "--dangerously-disable-package-manager-check",
    "content": "--dangerously-disable-package-manager-check"
  }, {
    "id": "--dry----dry-run",
    "content": "--dry / --dry-run"
  }, {
    "id": "--env-mode-option",
    "content": "--env-mode <option>"
  }, {
    "id": "strict",
    "content": "strict"
  }, {
    "id": "loose",
    "content": "loose"
  }, {
    "id": "--filter-string",
    "content": "--filter <string>"
  }, {
    "id": "필터링을-위한-마이크로-구문",
    "content": "필터링을 위한 마이크로 구문"
  }, {
    "id": "작업-식별자-사용",
    "content": "작업 식별자 사용"
  }, {
    "id": "고급-필터링-예제",
    "content": "고급 필터링 예제"
  }, {
    "id": "--force",
    "content": "--force"
  }, {
    "id": "--framework-inference",
    "content": "--framework-inference"
  }, {
    "id": "--global-deps-file-glob",
    "content": "--global-deps <file glob>"
  }, {
    "id": "--graph-file-name",
    "content": "--graph <file name>"
  }, {
    "id": "--log-order-option",
    "content": "--log-order <option>"
  }, {
    "id": "--log-prefix-option",
    "content": "--log-prefix <option>"
  }, {
    "id": "--no-cache",
    "content": "--no-cache"
  }, {
    "id": "--daemon-및---no-daemon",
    "content": "--daemon 및 --no-daemon"
  }, {
    "id": "--output-logs-option",
    "content": "--output-logs <option>"
  }, {
    "id": "--only",
    "content": "--only"
  }, {
    "id": "예시",
    "content": "예시"
  }, {
    "id": "--parallel",
    "content": "--parallel"
  }, {
    "id": "--preflight",
    "content": "--preflight"
  }, {
    "id": "--profile",
    "content": "--profile"
  }, {
    "id": "--remote-cache-timeout",
    "content": "--remote-cache-timeout"
  }, {
    "id": "--remote-only",
    "content": "--remote-only"
  }, {
    "id": "--summarize",
    "content": "--summarize"
  }, {
    "id": "--token",
    "content": "--token"
  }, {
    "id": "--team",
    "content": "--team"
  }, {
    "id": "--ui",
    "content": "--ui"
  }, {
    "id": "--verbosity",
    "content": "--verbosity"
  }]
};
import {Callout} from '#components/callout';
export const toc = [{
  depth: 2,
  url: "#옵션",
  title: _jsx(_Fragment, {
    children: "옵션"
  })
}, {
  depth: 3,
  url: "#--affected",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--affected"
    })
  })
}, {
  depth: 3,
  url: "#--cache-options",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--cache <options>"
    })
  })
}, {
  depth: 3,
  url: "#--cache-dir-path",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--cache-dir <path>"
    })
  })
}, {
  depth: 3,
  url: "#--concurrency-number--percentage",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--concurrency <number | percentage>"
    })
  })
}, {
  depth: 3,
  url: "#--continueoption",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--continue[=<option>]"
    })
  })
}, {
  depth: 3,
  url: "#--cwd-path",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--cwd <path>"
    })
  })
}, {
  depth: 3,
  url: "#--dangerously-disable-package-manager-check",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--dangerously-disable-package-manager-check"
    })
  })
}, {
  depth: 3,
  url: "#--dry----dry-run",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--dry / --dry-run"
    })
  })
}, {
  depth: 3,
  url: "#--env-mode-option",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--env-mode <option>"
    })
  })
}, {
  depth: 4,
  url: "#strict",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "strict"
    })
  })
}, {
  depth: 4,
  url: "#loose",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "loose"
    })
  })
}, {
  depth: 3,
  url: "#--filter-string",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--filter <string>"
    })
  })
}, {
  depth: 4,
  url: "#필터링을-위한-마이크로-구문",
  title: _jsx(_Fragment, {
    children: "필터링을 위한 마이크로 구문"
  })
}, {
  depth: 4,
  url: "#작업-식별자-사용",
  title: _jsx(_Fragment, {
    children: "작업 식별자 사용"
  })
}, {
  depth: 4,
  url: "#고급-필터링-예제",
  title: _jsx(_Fragment, {
    children: "고급 필터링 예제"
  })
}, {
  depth: 3,
  url: "#--force",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--force"
    })
  })
}, {
  depth: 3,
  url: "#--framework-inference",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--framework-inference"
    })
  })
}, {
  depth: 3,
  url: "#--global-deps-file-glob",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--global-deps <file glob>"
    })
  })
}, {
  depth: 3,
  url: "#--graph-file-name",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--graph <file name>"
    })
  })
}, {
  depth: 3,
  url: "#--log-order-option",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--log-order <option>"
    })
  })
}, {
  depth: 3,
  url: "#--log-prefix-option",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--log-prefix <option>"
    })
  })
}, {
  depth: 3,
  url: "#--no-cache",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--no-cache"
    })
  })
}, {
  depth: 3,
  url: "#--daemon-및---no-daemon",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--daemon"
    }), " 및 ", _jsx("code", {
      children: "--no-daemon"
    })]
  })
}, {
  depth: 3,
  url: "#--output-logs-option",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--output-logs <option>"
    })
  })
}, {
  depth: 3,
  url: "#--only",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--only"
    })
  })
}, {
  depth: 4,
  url: "#예시",
  title: _jsx(_Fragment, {
    children: "예시"
  })
}, {
  depth: 3,
  url: "#--parallel",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--parallel"
    })
  })
}, {
  depth: 3,
  url: "#--preflight",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--preflight"
    })
  })
}, {
  depth: 3,
  url: "#--profile",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--profile"
    })
  })
}, {
  depth: 3,
  url: "#--remote-cache-timeout",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--remote-cache-timeout"
    })
  })
}, {
  depth: 3,
  url: "#--remote-only",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--remote-only"
    })
  })
}, {
  depth: 3,
  url: "#--summarize",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--summarize"
    })
  })
}, {
  depth: 3,
  url: "#--token",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--token"
    })
  })
}, {
  depth: 3,
  url: "#--team",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--team"
    })
  })
}, {
  depth: 3,
  url: "#--ui",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--ui"
    })
  })
}, {
  depth: 3,
  url: "#--verbosity",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--verbosity"
    })
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo.json"
      }), "에 지정된 작업을 실행합니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " [tasks] [options] [-- [args passed to tasks]]"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[tasks]"
        }), ": Turborepo는 한 번에 하나 또는 여러 작업을 실행할 수 있습니다. ", _jsx(_components.code, {
          children: "turbo"
        }), "를 통해 작업을 실행하려면 ", _jsx(_components.code, {
          children: "turbo.json"
        }), "에 지정되어야 합니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[options]"
        }), ": 옵션은 ", _jsx(_components.code, {
          children: "turbo run"
        }), " 명령어의 동작을 제어하는 데 사용됩니다. 사용 가능한 플래그 옵션은 아래에 설명되어 있습니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "[-- [args passed to tasks]]"
        }), ": 하위 스크립트에 인수를 전달할 수도 있습니다. 모든 인수는 run 명령에 지정된 모든 작업에 전달됩니다."]
      }), "\n"]
    }), "\n", _jsx(Callout, {
      type: "good-to-know",
      children: _jsxs(_components.p, {
        children: [_jsx(_components.code, {
          children: "turbo run"
        }), "은 ", _jsx(_components.code, {
          children: "turbo"
        }), "의 별칭입니다. ", _jsx(_components.code, {
          children: "turbo run build lint check-types"
        }), "는\n", _jsx(_components.code, {
          children: "turbo build lint check-types"
        }), "와 동일합니다. 사용 편의성을 위해 ", _jsxs(_components.a, {
          href: "/docs/crafting-your-repository/constructing-ci#use-turbo-run-in-ci",
          children: ["CI\n파이프라인에서는 ", _jsx(_components.code, {
            children: "turbo   run"
          }), "을"]
        }), ",\n로컬에서는 ", _jsxs(_components.a, {
          href: "/docs/getting-started/installation#global-installation",
          children: ["전역\n", _jsx(_components.code, {
            children: "turbo"
          }), "와"]
        }), " 함께\n", _jsx(_components.code, {
          children: "turbo"
        }), "를 사용하는 것을 권장합니다."]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["작업이 제공되지 않으면 ", _jsx(_components.code, {
        children: "turbo"
      }), "는 저장소의 패키지에서 사용 가능한 작업을 표시합니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h2, {
      id: "옵션",
      children: "옵션"
    }), "\n", _jsx(_components.h3, {
      id: "--affected",
      children: _jsx(_components.code, {
        children: "--affected"
      })
    }), "\n", _jsx(_components.p, {
      children: "현재 브랜치의 변경 사항에 영향을 받는 패키지만 필터링합니다."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " lint"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " test"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --affected"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["기본적으로 이 플래그는 ", _jsx(_components.code, {
        children: "--filter=...[main...HEAD]"
      }), "와 동일합니다. 이는 Git의 관점에서 ", _jsx(_components.code, {
        children: "main"
      }), "과 ", _jsx(_components.code, {
        children: "HEAD"
      }), " 사이의 변경 사항을 고려합니다."]
    }), "\n", _jsxs(Callout, {
      type: "warn",
      children: [_jsx(_components.p, {
        children: "비교를 위해서는 base와 head 사이의 모든 내용이 체크아웃에 존재해야 합니다. 체크아웃이 너무 얕으면 모든 패키지가 변경된 것으로 간주됩니다."
      }), _jsxs(_components.p, {
        children: ["예를 들어, Git을 ", _jsx(_components.code, {
          children: "--filter=blob:none --depth=0"
        }), "으로 체크아웃하도록 설정하면 ", _jsx(_components.code, {
          children: "--affected"
        }), "가 올바르게 작동하는 데 필요한 히스토리를 확보할 수 있습니다."]
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["각각의 ", _jsx(_components.a, {
        href: "/docs/reference/system-environment-variables",
        children: "시스템 환경 변수"
      }), "를 사용하여 기본 base와 head를 재정의할 수 있습니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Git 비교 base 재정의"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "TURBO_SCM_BASE"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: "development"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --affected"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# Git 비교 head 재정의"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "TURBO_SCM_HEAD"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: "your-branch"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --affected"
            })]
          })]
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "--cache-options",
      children: _jsx(_components.code, {
        children: "--cache <options>"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["기본값: ", _jsx(_components.code, {
        children: "local:rw,remote:rw"
      })]
    }), "\n", _jsx(_components.p, {
      children: "실행할 캐싱 소스를 지정합니다. 쉼표로 구분된 옵션 목록을 허용합니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "local"
        }), ": 로컬 파일 시스템 캐시 사용"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "remote"
        }), ": Remote Cache 사용"]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "캐싱 소스가 생략되면 읽기와 쓰기가 모두 비활성화됩니다."
    }), "\n", _jsx(_components.p, {
      children: "캐시 소스는 다음 값을 사용합니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "rw"
        }), ": 읽기 및 쓰기"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "r"
        }), ": 읽기 전용"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "w"
        }), ": 쓰기 전용"]
      }), "\n", _jsxs(_components.li, {
        children: ["없음 (", _jsx(_components.code, {
          children: "local:"
        }), "): 캐시를 사용하지 않습니다. 캐시 소스 옵션을 생략하는 것과 동일합니다."]
      }), "\n"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# 로컬 캐시에서 읽기 및 쓰기. Remote Cache에서는 읽기만."
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --cache=local:rw,remote:r"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# 로컬 캐시에서는 읽기만. Remote Cache에서 읽기 및 쓰기."
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --cache=local:r,remote:rw"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# 로컬 캐시에서 읽기 및 쓰기. Remote Cache 활동 없음."
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --cache=local:rw"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# 로컬 캐시를 사용하지 않음. Remote Cache에서는 읽기만."
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --cache=local:,remote:r"
            })]
          })]
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "--cache-dir-path",
      children: _jsx(_components.code, {
        children: "--cache-dir <path>"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["기본값: ", _jsx(_components.code, {
        children: ".turbo/cache"
      })]
    }), "\n", _jsx(_components.p, {
      children: "파일 시스템 캐시 디렉토리를 지정합니다."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --cache-dir="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"./my-cache\""
            })]
          })
        })
      })
    }), "\n", _jsx(Callout, {
      type: "warn",
      children: _jsxs(_components.p, {
        children: ["변경할 때 디렉토리가 ", _jsx(_components.code, {
          children: ".gitignore"
        }), "에 있는지 확인하세요."]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["동일한 동작은 ", _jsx(_components.code, {
        children: "TURBO_CACHE_DIR=example/path"
      }), " 시스템 변수를 통해서도 설정할 수 있습니다."]
    }), "\n", _jsx(_components.h3, {
      id: "--concurrency-number--percentage",
      children: _jsx(_components.code, {
        children: "--concurrency <number | percentage>"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["기본값: ", _jsx(_components.code, {
        children: "10"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["작업 실행의 최대 동시성을 설정/제한합니다. ", _jsx(_components.code, {
        children: "1"
      }), " 이상의 정수 또는 ", _jsx(_components.code, {
        children: "50%"
      }), "와 같은 백분율 값이어야 합니다."]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["직렬 실행(한 번에 하나의 작업)을 강제하려면 ", _jsx(_components.code, {
          children: "1"
        }), "을 사용합니다."]
      }), "\n", _jsxs(_components.li, {
        children: ["사용 가능한 모든 논리 프로세서를 사용하려면 ", _jsx(_components.code, {
          children: "100%"
        }), "를 사용합니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#--parallel",
          children: _jsx(_components.code, {
            children: "--parallel"
          })
        }), " 플래그도 전달되면 이 옵션은 무시됩니다."]
      }), "\n"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --concurrency=50%"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " test"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --concurrency=5"
            })]
          })]
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "--continueoption",
      children: _jsx(_components.code, {
        children: "--continue[=<option>]"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["기본값: ", _jsx(_components.code, {
        children: "never"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["오류가 발생할 때(예: 작업에서 0이 아닌 종료 코드) ", _jsx(_components.code, {
        children: "turbo"
      }), "가 현재 및 대기 중인 작업을 처리하는 방법을 지정합니다."]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--continue=never"
        }), "이고 오류가 발생하면 ", _jsx(_components.code, {
          children: "turbo"
        }), "는 모든 작업을 취소합니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--continue=dependencies-successful"
        }), "이고 오류가 발생하면 ", _jsx(_components.code, {
          children: "turbo"
        }), "는 종속 작업을 취소합니다. 종속성이 성공한 작업은 계속 실행됩니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--continue=always"
        }), "이고 오류가 발생하면 ", _jsx(_components.code, {
          children: "turbo"
        }), "는 종속성이 실패한 작업을 포함하여 모든 작업을 계속 실행합니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--continue"
        }), "가 값 없이 지정되면 기본값은 ", _jsx(_components.code, {
          children: "always"
        }), "입니다."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["모든 경우에 ", _jsx(_components.code, {
        children: "turbo"
      }), "는 실행 중 발생한 가장 높은 종료 코드 값으로 종료됩니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --continue"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "--cwd-path",
      children: _jsx(_components.code, {
        children: "--cwd <path>"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["기본값: 루트 ", _jsx(_components.code, {
        children: "turbo.json"
      }), "의 디렉토리"]
    }), "\n", _jsx(_components.p, {
      children: "명령의 작업 디렉토리를 설정합니다."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --cwd=./somewhere/else/in/your/repo"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "--dangerously-disable-package-manager-check",
      children: _jsx(_components.code, {
        children: "--dangerously-disable-package-manager-check"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo는 저장소의 lockfile을 사용하여 캐싱 동작, ", _jsx(_components.a, {
        href: "https://turborepo.com/docs/core-concepts/internal-packages",
        children: "패키지 그래프"
      }), " 등을 결정합니다. 이 때문에 Turborepo를 안정화하는 데 도움이 되도록 ", _jsxs(_components.a, {
        href: "https://nodejs.org/api/packages.html#packagemanager",
        children: [_jsx(_components.code, {
          children: "packageManager"
        }), " 필드"]
      }), "를 사용합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["점진적 마이그레이션을 돕거나 ", _jsx(_components.code, {
        children: "packageManager"
      }), " 필드를 사용할 수 없는 상황에서 ", _jsx(_components.code, {
        children: "--dangerously-disable-package-manager-check"
      }), "를 사용하여 이 검사를 선택 해제하고 불안정한 lockfile이 예측할 수 없는 동작을 생성할 위험을 감수할 수 있습니다. 비활성화되면 Turborepo는 저장소에 의도된 패키지 매니저를 최선의 노력으로 검색을 시도합니다."]
    }), "\n", _jsx(Callout, {
      type: "info",
      children: _jsxs(_components.p, {
        children: ["더 광범위한 적용을 위해 ", _jsxs(_components.a, {
          href: "/docs/reference/configuration#dangerouslydisablepacakgemanagercheck",
          children: [_jsx(_components.code, {
            children: "turbo.json"
          }), "의\n설정"]
        }), "\n또는\n", _jsx(_components.a, {
          href: "/docs/reference/system-environment-variables",
          children: _jsx(_components.code, {
            children: "TURBO_DANGEROUSLY_DISABLE_PACKAGE_MANAGER_CHECK"
          })
        }), "\n환경 변수를 사용하여 이 검사를 선택 해제할 수도 있습니다."]
      })
    }), "\n", _jsx(_components.h3, {
      id: "--dry----dry-run",
      children: _jsx(_components.code, {
        children: "--dry / --dry-run"
      })
    }), "\n", _jsx(_components.p, {
      children: "작업을 실행하는 대신 실행될 패키지와 작업에 대한 세부 정보를 표시합니다."
    }), "\n", _jsxs(_components.p, {
      children: ["JSON 형식으로 출력을 얻으려면 ", _jsx(_components.code, {
        children: "--dry=json"
      }), "을 지정합니다."]
    }), "\n", _jsx(_components.p, {
      children: "작업 세부 정보에는 다음과 같은 유용한 정보가 포함됩니다(목록은 전체가 아님):"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "필드"
          }), _jsx(_components.th, {
            children: "설명"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "taskId"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "package-name#task-name"
            }), " 형식의 작업 ID"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "task"
            })
          }), _jsx(_components.td, {
            children: "실행할 작업의 이름"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "package"
            })
          }), _jsx(_components.td, {
            children: "작업을 실행할 패키지"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "hash"
            })
          }), _jsx(_components.td, {
            children: "작업의 해시(캐싱에 사용됨)"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "hashOfExternalDependencies"
            })
          }), _jsx(_components.td, {
            children: "전역 해시"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "command"
            })
          }), _jsx(_components.td, {
            children: "작업을 실행하는 데 사용되는 명령"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "inputs"
            })
          }), _jsx(_components.td, {
            children: "해싱을 위해 고려된 파일 입력 목록"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "outputs"
            })
          }), _jsx(_components.td, {
            children: "캐시된 파일 출력 목록"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "dependencies"
            })
          }), _jsxs(_components.td, {
            children: ["이 작업 ", _jsx(_components.strong, {
              children: "이전에"
            }), " 실행되어야 하는 작업"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "dependents"
            })
          }), _jsxs(_components.td, {
            children: ["이 작업 ", _jsx(_components.strong, {
              children: "이후에"
            }), " 실행되어야 하는 작업"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "environmentVariables"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "env"
            }), " 및 ", _jsx(_components.code, {
              children: "passThroughEnv"
            }), "에 지정된 환경 변수 목록"]
          })]
        })]
      })]
    }), "\n", _jsx(_components.h3, {
      id: "--env-mode-option",
      children: _jsx(_components.code, {
        children: "--env-mode <option>"
      })
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.code, {
        children: "type: string"
      })
    }), "\n", _jsx(_components.p, {
      children: "작업의 런타임에서 사용 가능한 환경 변수를 제어합니다."
    }), "\n", _jsx(Callout, {
      type: "good-to-know",
      children: _jsxs(_components.p, {
        children: [_jsx(_components.code, {
          children: "PATH"
        }), ", ", _jsx(_components.code, {
          children: "SHELL"
        }), ", ", _jsx(_components.code, {
          children: "SYSTEMROOT"
        }), "는 항상 작업에서 사용할 수 있습니다."]
      })
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "옵션"
          }), _jsx(_components.th, {
            children: "설명"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsxs(_components.td, {
            children: [_jsx(_components.a, {
              href: "#strict",
              children: "strict"
            }), " (기본값)"]
          }), _jsx(_components.td, {
            children: "명시적으로 나열된 환경 변수만 사용 가능하도록 허용"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.a, {
              href: "#loose",
              children: "loose"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.strong, {
              children: "모든"
            }), " 환경 변수를 사용 가능하도록 허용"]
          })]
        })]
      })]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --env-mode=loose"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["동일한 동작은 ", _jsx(_components.code, {
        children: "TURBO_ENV_MODE=strict"
      }), " 시스템 변수를 통해서도 설정할 수 있습니다."]
    }), "\n", _jsx(_components.h4, {
      id: "strict",
      children: _jsx(_components.code, {
        children: "strict"
      })
    }), "\n", _jsx(_components.p, {
      children: "다음 키에 지정된 환경 변수만 작업에서 사용할 수 있습니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/reference/configuration#env",
          children: _jsx(_components.code, {
            children: "env"
          })
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/reference/configuration#passthroughenv",
          children: _jsx(_components.code, {
            children: "passThroughEnv"
          })
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/reference/configuration#globalenv",
          children: _jsx(_components.code, {
            children: "globalEnv"
          })
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/reference/configuration#globalpassthroughenv",
          children: _jsx(_components.code, {
            children: "globalPassThroughEnv"
          })
        })
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["엄격 모드가 지정되거나 추론되면 구성에 관계없이 ", _jsx(_components.strong, {
        children: "모든"
      }), " 작업이 ", _jsx(_components.code, {
        children: "strict"
      }), " 모드에서 실행됩니다."]
    }), "\n", _jsx(_components.h4, {
      id: "loose",
      children: _jsx(_components.code, {
        children: "loose"
      })
    }), "\n", _jsx(_components.p, {
      children: "머신의 모든 환경 변수가 작업의 런타임에서 사용 가능하게 됩니다."
    }), "\n", _jsx(Callout, {
      type: "warn",
      children: _jsxs(_components.p, {
        children: ["위의 ", _jsx(_components.code, {
          children: "strict"
        }), "에 나열된 키로 캐싱에 환경 변수가 고려되지 않을 때 위험할 수\n있습니다. ", _jsx(_components.code, {
          children: "loose"
        }), " 모드에서는 캐시에서 잘못된 환경 변수로 패키지 버전을 복원할\n가능성이 훨씬 높습니다."]
      })
    }), "\n", _jsx(_components.h3, {
      id: "--filter-string",
      children: _jsx(_components.code, {
        children: "--filter <string>"
      })
    }), "\n", _jsx(_components.p, {
      children: "저장소 그래프에서 실행할 대상을 지정합니다. 여러 필터를 결합하여 고유한 대상 집합을 선택할 수 있습니다."
    }), "\n", _jsx(_components.p, {
      children: "필터를 결합하여 패키지, 디렉토리, git 커밋의 조합을 만들 수 있습니다."
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "대상 유형"
          }), _jsx(_components.th, {
            children: "설명"
          }), _jsx(_components.th, {
            children: "예시"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Package"
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "package.json"
            }), "의 이름으로 패키지를 선택합니다."]
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "turbo run build --filter=ui"
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Directory"
          }), _jsxs(_components.td, {
            children: ["작업을 실행할 패키지 목록을 캡처하기 위해 디렉토리를 지정합니다. ", _jsxs(_components.strong, {
              children: ["다른 필터와 함께 사용할 때는 ", _jsx(_components.code, {
                children: "{}"
              }), "로 래핑해야 합니다"]
            }), "."]
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "turbo run build --filter=./apps/*"
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Git commits"
          }), _jsxs(_components.td, {
            children: ["Git 지정자를 사용하여 소스 제어 변경 사항이 있는 패키지를 지정합니다. ", _jsxs(_components.strong, {
              children: [_jsx(_components.code, {
                children: "[]"
              }), "로 래핑해야 합니다"]
            }), "."]
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "turbo run build --filter=[HEAD^1]"
            })
          })]
        })]
      })]
    }), "\n", _jsxs(Callout, {
      type: "good-to-know",
      children: [_jsx(_components.code, {
        children: "-F"
      }), "는 ", _jsx(_components.code, {
        children: "--filter"
      }), "의 별칭입니다."]
    }), "\n", _jsx(_components.h4, {
      id: "필터링을-위한-마이크로-구문",
      children: "필터링을 위한 마이크로 구문"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "!"
        }), ": 선택에서 대상을 제외합니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "..."
        }), " 패키지 사용: 대상을 기준으로 ", _jsx(_components.a, {
          href: "/docs/core-concepts/package-and-task-graph#package-graph",
          children: "패키지 그래프"
        }), "의 모든 패키지를 선택합니다. 패키지 이름 ", _jsx(_components.strong, {
          children: "앞에"
        }), " ", _jsx(_components.code, {
          children: "..."
        }), "를 사용하면 대상의 ", _jsx(_components.strong, {
          children: "종속자"
        }), "를 선택하고, 패키지 이름 ", _jsx(_components.strong, {
          children: "뒤에"
        }), " ", _jsx(_components.code, {
          children: "..."
        }), "를 사용하면 대상의 ", _jsx(_components.strong, {
          children: "종속성"
        }), "을 선택합니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "..."
        }), " Git 커밋 사용: ", _jsx(_components.code, {
          children: "[<from commit>]...[<to commit>]"
        }), "를 사용하여 범위를 선택합니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "^"
        }), ": ", _jsx(_components.code, {
          children: "..."
        }), "를 사용할 때 선택에서 대상을 생략합니다."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["필터링에 대한 심층적인 논의와 실용적인 사용 사례는 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/running-tasks",
        children: "작업 실행 페이지"
      }), "를 참조하세요."]
    }), "\n", _jsx(_components.h4, {
      id: "작업-식별자-사용",
      children: "작업 식별자 사용"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "package-name#task-name"
      }), " 형식으로 특정 패키지에 대한 특정 작업을 실행할 수도 있습니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " web#lint"
            })]
          })
        })
      })
    }), "\n", _jsx(Callout, {
      type: "good-to-know",
      children: _jsxs(_components.p, {
        children: ["이것은 작업의 종속성도 실행합니다. 종속성 없이 작업을 실행하려면 ", _jsxs(_components.a, {
          href: "#--only",
          children: [_jsx(_components.code, {
            children: "--only"
          }), "\n플래그"]
        }), "를 사용하세요."]
      })
    }), "\n", _jsx(_components.h4, {
      id: "고급-필터링-예제",
      children: "고급 필터링 예제"
    }), "\n", _jsx(_components.p, {
      children: "여러 필터를 결합하여 대상을 더욱 세밀하게 조정할 수 있습니다. 여러 필터는 합집합으로 결합되며, 부정 필터는 합집합의 결과에서 패키지를 제거합니다."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# 마지막 커밋 이후 변경된 `apps` 하위 디렉토리의 모든 패키지"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: ".apps/*}[HEAD^1]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# ./apps/admin을 제외한 `apps` 하위 디렉토리의 모든 패키지"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter=./apps/"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "*"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter=!./apps/admin"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# docs 및 web 패키지에 대한 build 작업 실행"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter=docs"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter=web"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# 'my-feature' 브랜치의 변경 사항에 의존하는 모든 것을 빌드"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter=...[origin/my-feature]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# 두 Git SHA 사이의 변경 사항에 의존하는 모든 것을 빌드"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter=[a1b2c3d...e4f5g6h]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# 다음과 같은 경우 '@acme/ui'를 빌드:"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# - 이전 커밋 이후 이 패키지 또는 그 종속성 중 하나가 변경된 경우"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter=@acme/ui...[HEAD^1]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# 다음 각 패키지를 테스트:"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# - '@acme' 스코프에 있는 패키지"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# - 또는 'packages' 디렉토리에 있는 패키지"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "# - 또는 이전 커밋 이후 변경된 패키지"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " test"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter=@acme/"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "*"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "./packages/*}[HEAD^1]"
            })]
          })]
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "--force",
      children: _jsx(_components.code, {
        children: "--force"
      })
    }), "\n", _jsx(_components.p, {
      children: "기존 캐시된 아티팩트를 무시하고 모든 작업을 다시 실행합니다."
    }), "\n", _jsxs(Callout, {
      type: "good-to-know",
      children: [_jsx(_components.code, {
        children: "--force"
      }), "는 기존 작업 캐시를 덮어씁니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --force"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["동일한 동작은 ", _jsxs(_components.a, {
        href: "/docs/reference/system-environment-variables",
        children: [_jsx(_components.code, {
          children: "TURBO_FORCE"
        }), " 환경 변수"]
      }), "를 통해서도 설정할 수 있습니다."]
    }), "\n", _jsx(_components.h3, {
      id: "--framework-inference",
      children: _jsx(_components.code, {
        children: "--framework-inference"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["기본값: ", _jsx(_components.code, {
        children: "true"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["작업에 대해 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/using-environment-variables#framework-inference",
        children: "프레임워크 추론"
      }), "을 수행할지 여부를 지정합니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "false"
      }), "일 때 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/using-environment-variables#framework-inference",
        children: "자동 환경 변수 포함"
      }), "이 비활성화됩니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --framework-inference=false"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "--global-deps-file-glob",
      children: _jsx(_components.code, {
        children: "--global-deps <file glob>"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["해시화할 전역 파일 시스템 종속성의 glob을 지정합니다. 여러 패키지에 영향을 미치는 ", _jsx(_components.code, {
        children: ".env"
      }), " 및 루트 디렉토리의 파일에 유용합니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --global-deps="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\".env\""
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --global-deps="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\".env.*\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --global-deps="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\".eslintrc\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --global-deps="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"jest.config.ts\""
            })]
          })]
        })
      })
    }), "\n", _jsx(Callout, {
      type: "info",
      children: _jsxs(_components.p, {
        children: ["항상 고려되도록 하기 위해 ", _jsx(_components.code, {
          children: "turbo.json"
        }), "의 ", _jsxs(_components.a, {
          href: "/docs/reference/configuration#globaldeps",
          children: [_jsx(_components.code, {
            children: "globalDependencies"
          }), "\n키"]
        }), "에 해시에 포함하려는 파일 glob을\n지정하는 것을 권장합니다."]
      })
    }), "\n", _jsx(_components.h3, {
      id: "--graph-file-name",
      children: _jsx(_components.code, {
        children: "--graph <file name>"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["기본값: ", _jsx(_components.code, {
        children: "dot"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["이 명령은 그래프 파일을 출력할 수 있습니다: ", _jsx(_components.code, {
        children: "svg"
      }), ", ", _jsx(_components.code, {
        children: "png"
      }), ", ", _jsx(_components.code, {
        children: "jpg"
      }), ", ", _jsx(_components.code, {
        children: "pdf"
      }), ", ", _jsx(_components.code, {
        children: "json"
      }), ", ", _jsx(_components.code, {
        children: "html"
      }), ", ", _jsx(_components.code, {
        children: "mermaid"
      }), " 또는 ", _jsx(_components.code, {
        children: "dot"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://graphviz.org/",
        children: "Graphviz"
      }), "가 설치되지 않았거나 파일 이름이 제공되지 않으면 이 명령은 dot 그래프를 ", _jsx(_components.code, {
        children: "stdout"
      }), "에 출력합니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --graph"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " test"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " lint"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --graph=my-graph.svg"
            })]
          })]
        })
      })
    }), "\n", _jsx(Callout, {
      type: "info",
      children: _jsxs(_components.p, {
        children: [_jsx(_components.strong, {
          children: "알려진 버그"
        }), ": 현재 특정 패키지에 해당 스크립트가 실제로 존재하지 않더라도\n모든 가능한 작업 노드가 그래프에 추가됩니다. 이는 실행에는 영향을 미치지\n않지만 그래프가 관련된 패키지와 작업의 수를 과대평가할 수 있습니다."]
      })
    }), "\n", _jsx(_components.h3, {
      id: "--log-order-option",
      children: _jsx(_components.code, {
        children: "--log-order <option>"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["기본값: ", _jsx(_components.code, {
        children: "auto"
      })]
    }), "\n", _jsx(_components.p, {
      children: "로그 출력의 순서를 설정합니다."
    }), "\n", _jsxs(_components.p, {
      children: ["기본적으로 ", _jsx(_components.code, {
        children: "turbo"
      }), "는 CI 환경에서 ", _jsx(_components.code, {
        children: "grouped"
      }), " 로그를, 다른 곳에서는 ", _jsx(_components.code, {
        children: "stream"
      }), " 로그를 사용합니다. 이 플래그는 ", _jsx(_components.a, {
        href: "https://turborepo.com/docs/reference/configuration#ui",
        children: "터미널 UI"
      }), "를 사용할 때는 적용되지 않습니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --log-order=stream"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "옵션"
          }), _jsx(_components.th, {
            children: "설명"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "stream"
            })
          }), _jsx(_components.td, {
            children: "사용 가능한 즉시 출력을 표시합니다"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "grouped"
            })
          }), _jsx(_components.td, {
            children: "작업별로 출력을 그룹화합니다"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "auto"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "turbo"
            }), "가 자체 휴리스틱을 기반으로 결정합니다"]
          })]
        })]
      })]
    }), "\n", _jsx(_components.h3, {
      id: "--log-prefix-option",
      children: _jsx(_components.code, {
        children: "--log-prefix <option>"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["기본값: ", _jsx(_components.code, {
        children: "auto"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["작업 실행 시 생성되는 로그 라인의 ", _jsx(_components.code, {
        children: "<package>:<task>:"
      }), " 접두사를 제어합니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " dev"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --log-prefix=none"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "옵션"
          }), _jsx(_components.th, {
            children: "설명"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "task"
            })
          }), _jsxs(_components.td, {
            children: ["로그에 ", _jsx(_components.code, {
              children: "<package>:<task>:"
            }), " 접두사를 강제로 추가합니다"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "none"
            })
          }), _jsx(_components.td, {
            children: "접두사 없음"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "auto"
            })
          }), _jsxs(_components.td, {
            children: [_jsx(_components.code, {
              children: "turbo"
            }), "가 자체 휴리스틱을 기반으로 결정합니다"]
          })]
        })]
      })]
    }), "\n", _jsx(_components.h3, {
      id: "--no-cache",
      children: _jsx(_components.code, {
        children: "--no-cache"
      })
    }), "\n", _jsx(Callout, {
      type: "warn",
      title: "사용 중단됨",
      children: _jsxs(_components.p, {
        children: ["이 플래그는 향후 주요 릴리스에서 제거될 예정입니다. 대신\n", _jsx(_components.a, {
          href: "#--cache-options",
          children: _jsx(_components.code, {
            children: "--cache"
          })
        }), " 플래그를 사용하세요."]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["기본값: ", _jsx(_components.code, {
        children: "false"
      })]
    }), "\n", _jsx(_components.p, {
      children: "작업의 결과를 캐시하지 않습니다."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " dev"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --no-cache"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "--daemon-및---no-daemon",
      children: [_jsx(_components.code, {
        children: "--daemon"
      }), " 및 ", _jsx(_components.code, {
        children: "--no-daemon"
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo"
      }), "는 수행해야 할 작업을 결정하는 데 사용되는 값을 사전 계산하기 위해 백그라운드 프로세스를 실행할 수 있습니다. 이 독립 실행형 프로세스(daemon)는 최적화이며 ", _jsx(_components.code, {
        children: "turbo"
      }), "의 적절한 기능에는 필요하지 않습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["기본 daemon 사용은 ", _jsxs(_components.a, {
        href: "/docs/reference/configuration#daemon",
        children: [_jsx(_components.code, {
          children: "turbo.json"
        }), "의 ", _jsx(_components.code, {
          children: "daemon"
        }), " 필드"]
      }), "를 사용하여 저장소에 대해 설정됩니다. ", _jsx(_components.code, {
        children: "--daemon"
      }), "을 전달하면 ", _jsx(_components.code, {
        children: "turbo"
      }), "가 독립 실행형 프로세스를 사용해야 하며, ", _jsx(_components.code, {
        children: "--no-daemon"
      }), "은 ", _jsx(_components.code, {
        children: "turbo"
      }), "가 독립 실행형 프로세스를 사용하거나 생성하지 않도록 지시합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["동일한 동작은 ", _jsx(_components.code, {
        children: "TURBO_DAEMON=true"
      }), " 시스템 변수를 통해서도 설정할 수 있습니다."]
    }), "\n", _jsx(_components.h3, {
      id: "--output-logs-option",
      children: _jsx(_components.code, {
        children: "--output-logs <option>"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["기본값: ", _jsx(_components.code, {
        children: "full"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["출력 로깅 유형을 설정하며, ", _jsx(_components.code, {
        children: "turbo.json"
      }), "에 정의된 경우 ", _jsx(_components.a, {
        href: "/docs/reference/configuration#outputlogs",
        children: _jsx(_components.code, {
          children: "outputLogs"
        })
      }), "를 재정의합니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --output-logs=errors-only"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "옵션"
          }), _jsx(_components.th, {
            children: "설명"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "full"
            })
          }), _jsx(_components.td, {
            children: "모든 로그를 표시합니다"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "hash-only"
            })
          }), _jsx(_components.td, {
            children: "작업의 해시만 표시합니다"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "new-only"
            })
          }), _jsx(_components.td, {
            children: "캐시 미스의 로그만 표시합니다"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "errors-only"
            })
          }), _jsx(_components.td, {
            children: "작업 실패의 로그만 표시합니다"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "none"
            })
          }), _jsx(_components.td, {
            children: "모든 작업 로그를 숨깁니다"
          })]
        })]
      })]
    }), "\n", _jsx(_components.h3, {
      id: "--only",
      children: _jsx(_components.code, {
        children: "--only"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["기본값: ", _jsx(_components.code, {
        children: "false"
      })]
    }), "\n", _jsx(_components.p, {
      children: "실행을 지정된 작업만 포함하도록 제한합니다."
    }), "\n", _jsx(_components.h4, {
      id: "예시",
      children: "예시"
    }), "\n", _jsxs(_components.p, {
      children: ["다음 ", _jsx(_components.code, {
        children: "turbo.json"
      }), "이 주어졌을 때:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"$schema\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"https://turborepo.com/schema.json\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"^build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"test\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"dependsOn\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"^build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " test"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --only"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["이 명령은 각 패키지의 ", _jsx(_components.code, {
        children: "test"
      }), " 작업만 실행합니다. ", _jsx(_components.code, {
        children: "build"
      }), "는 실행하지 않습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["또한 ", _jsx(_components.code, {
        children: "--only"
      }), "는 종속성을 제외하고 지정된 패키지의 작업만 실행합니다. 예를 들어, ", _jsx(_components.code, {
        children: "turbo run build --filter=web --only"
      }), "는 ", _jsx(_components.code, {
        children: "web"
      }), " 패키지의 ", _jsx(_components.code, {
        children: "build"
      }), " 스크립트만 실행합니다."]
    }), "\n", _jsx(_components.h3, {
      id: "--parallel",
      children: _jsx(_components.code, {
        children: "--parallel"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["기본값: ", _jsx(_components.code, {
        children: "false"
      })]
    }), "\n", _jsx(_components.p, {
      children: "작업 종속성 그래프를 무시하고 패키지 간에 명령을 병렬로 실행합니다."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " lint"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --parallel"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " dev"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --parallel"
            })]
          })]
        })
      })
    }), "\n", _jsx(Callout, {
      type: "info",
      children: _jsxs(_components.p, {
        children: [_jsx(_components.code, {
          children: "--parallel"
        }), " 플래그는 일반적으로 종료되지 않는 장기 실행 \"dev\" 또는 \"watch\"\n작업에 사용됩니다. ", _jsx(_components.code, {
          children: "turbo@1.7"
        }), "부터는 대신\n", _jsx(_components.a, {
          href: "/docs/reference/configuration#persistent",
          children: _jsx(_components.code, {
            children: "persistent"
          })
        }), "를 사용하여 이러한\n작업을 구성하는 것을 권장합니다."]
      })
    }), "\n", _jsx(_components.h3, {
      id: "--preflight",
      children: _jsx(_components.code, {
        children: "--preflight"
      })
    }), "\n", _jsx(_components.p, {
      children: "Remote Caching이 구성된 경우에만 적용됩니다. 모든 캐시 아티팩트 및 분석 요청 전에 preflight 요청 전송을 활성화합니다. 후속 업로드 및 다운로드는 리디렉션을 따릅니다."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --preflight"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["동일한 동작은 ", _jsx(_components.code, {
        children: "TURBO_PREFLIGHT=true"
      }), " 시스템 변수를 통해서도 설정할 수 있습니다."]
    }), "\n", _jsx(_components.h3, {
      id: "--profile",
      children: _jsx(_components.code, {
        children: "--profile"
      })
    }), "\n", _jsx(_components.p, {
      children: "성능 분석에 사용할 수 있는 Chrome Tracing 형식의 실행 추적을 생성합니다."
    }), "\n", _jsxs(_components.p, {
      children: ["추적을 생성하려면 ", _jsx(_components.code, {
        children: "--profile"
      }), "과 함께 자세한 정도 플래그(", _jsx(_components.code, {
        children: "-v"
      }), ", ", _jsx(_components.code, {
        children: "-vv"
      }), " 또는 ", _jsx(_components.code, {
        children: "-vvv"
      }), ")를 제공해야 합니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --profile=profile.json"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " -vvv"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["프로필은 ", _jsx(_components.a, {
        href: "https://ui.perfetto.dev/",
        children: "Perfetto"
      }), "와 같은 도구에서 볼 수 있습니다."]
    }), "\n", _jsx(_components.h3, {
      id: "--remote-cache-timeout",
      children: _jsx(_components.code, {
        children: "--remote-cache-timeout"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["기본값: ", _jsx(_components.code, {
        children: "30"
      })]
    }), "\n", _jsx(_components.p, {
      children: "Remote Cache 작업의 타임아웃을 초 단위로 설정합니다."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --remote-cache-timeout=60"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "--remote-only",
      children: _jsx(_components.code, {
        children: "--remote-only"
      })
    }), "\n", _jsx(Callout, {
      type: "warn",
      title: "사용 중단됨",
      children: _jsxs(_components.p, {
        children: ["이 플래그는 향후 주요 릴리스에서 제거될 예정입니다. 대신\n", _jsx(_components.a, {
          href: "#--cache-options",
          children: _jsx(_components.code, {
            children: "--cache"
          })
        }), " 플래그를 사용하세요."]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["기본값: ", _jsx(_components.code, {
        children: "false"
      })]
    }), "\n", _jsx(_components.p, {
      children: "모든 작업에 대해 로컬 파일 시스템 캐시를 무시하고 Remote Cache를 사용하여 작업 출력을 읽고 캐싱합니다."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --remote-only"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "--summarize",
      children: _jsx(_components.code, {
        children: "--summarize"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["다음을 포함하여 실행에 대한 메타데이터가 포함된 JSON 파일을 ", _jsx(_components.code, {
        children: ".turbo/runs"
      }), "에 생성합니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "영향을 받은 패키지"
      }), "\n", _jsx(_components.li, {
        children: "실행된 작업(타이밍 및 해시 포함)"
      }), "\n", _jsx(_components.li, {
        children: "캐시된 아티팩트에 포함된 모든 파일"
      }), "\n"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --summarize"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "이 플래그는 다음과 같은 항목을 확인하기 위한 디버깅에 유용할 수 있습니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "turbo"
        }), "가 ", _jsx(_components.code, {
          children: "inputs"
        }), " 및 ", _jsx(_components.code, {
          children: "outputs"
        }), "에 대한 glob 구문을 해석한 방법"]
      }), "\n", _jsx(_components.li, {
        children: "캐시 미스를 발생시키기 위해 두 작업 실행 사이에 변경된 입력"
      }), "\n", _jsx(_components.li, {
        children: "시간이 지남에 따라 작업 타이밍이 어떻게 변경되었는지"
      }), "\n"]
    }), "\n", _jsx(Callout, {
      type: "info",
      title: "요약 뷰어",
      children: _jsxs(_components.p, {
        children: ["Turborepo 네이티브 실행 요약 UI 뷰어는 없지만, 실행 요약을 웹 뷰로 보려면\n커뮤니티에서 만든\n", _jsx(_components.a, {
          href: "https://turbo.nullvoxpopuli.com",
          children: "https://turbo.nullvoxpopuli.com"
        }), "을 사용하는\n것을 권장합니다."]
      })
    }), "\n", _jsx(_components.h3, {
      id: "--token",
      children: _jsx(_components.code, {
        children: "--token"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Remote Caching을 위한 bearer 토큰입니다. ", _jsx(_components.code, {
        children: "--team"
      }), " 플래그와 함께 비대화형 셸에서 실행할 때 유용합니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --team=my-team"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --token=xxxxxxxxxxxxxxxxx"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["이 값은 ", _jsxs(_components.a, {
        href: "/docs/reference/system-environment-variables",
        children: [_jsx(_components.code, {
          children: "TURBO_TOKEN"
        }), " 시스템 변수"]
      }), "를 사용하여 설정할 수도 있습니다. 둘 다 있는 경우 플래그 값이 시스템 변수를 재정의합니다."]
    }), "\n", _jsx(Callout, {
      type: "good-to-know",
      children: _jsxs(_components.p, {
        children: [_jsx(_components.a, {
          href: "https://vercel.com/docs/monorepos/remote-caching",
          children: "Vercel Remote Cache"
        }), "를\n사용하고 Vercel에서 프로젝트를 빌드하는 경우 이 플래그를 사용할 필요가\n없습니다. 이 값은 자동으로 설정됩니다."]
      })
    }), "\n", _jsx(_components.h3, {
      id: "--team",
      children: _jsx(_components.code, {
        children: "--team"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Remote Cache 팀의 슬러그입니다. ", _jsx(_components.code, {
        children: "--token"
      }), " 플래그와 함께 비대화형 셸에서 실행할 때 유용합니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --team=my-team"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --team=my-team"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --token=xxxxxxxxxxxxxxxxx"
            })]
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["이 값은 ", _jsxs(_components.a, {
        href: "/docs/reference/system-environment-variables",
        children: [_jsx(_components.code, {
          children: "TURBO_TEAM"
        }), " 시스템 변수"]
      }), "를 사용하여 설정할 수도 있습니다. 둘 다 있는 경우 플래그 값이 시스템 변수를 재정의합니다."]
    }), "\n", _jsx(_components.h3, {
      id: "--ui",
      children: _jsx(_components.code, {
        children: "--ui"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["출력에 사용할 UI를 지정합니다. ", _jsx(_components.code, {
        children: "stream"
      }), " 또는 ", _jsx(_components.code, {
        children: "tui"
      }), "를 허용합니다."]
    }), "\n", _jsx(_components.h3, {
      id: "--verbosity",
      children: _jsx(_components.code, {
        children: "--verbosity"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["로그 레벨을 지정하려면 ", _jsx(_components.code, {
        children: "--verbosity=<num>"
      }), " 또는 ", _jsx(_components.code, {
        children: "-v, -vv, -vvv"
      }), "를 사용합니다."]
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "레벨"
          }), _jsx(_components.th, {
            children: "플래그 값"
          }), _jsx(_components.th, {
            children: "단축형"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Info"
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "--verbosity=1"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "-v"
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Debug"
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "--verbosity=2"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "-vv"
            })
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Trace"
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "--verbosity=3"
            })
          }), _jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "-vvv"
            })
          })]
        })]
      })]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --verbosity=2"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " -vvv"
            })]
          })]
        })
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
